import { render } from "./LogbookItem.vue?vue&type=template&id=3e54d15e"
import script from "./LogbookItem.vue?vue&type=script&lang=js"
export * from "./LogbookItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__